import { Stores } from "../pages/Stores/Stores";
import { Products } from "../pages/Products/Products";
import { Home } from "../pages/home/Home";
import { Orders } from "../pages/Orders/Orders";
import { Reports } from "../pages/Reports/Reports";
import { Profile } from "../pages/Profile/Profile";
import { CreateOrder } from "../pages/Orders/CreateOrder";
import { ProductDetails } from "../pages/Products/ProductDetails";
import { OrderHistory } from "../pages/Orderhistory/OrderHistory";
import { OrderHistoryDetails } from "../pages/Orderhistory/OrderHistoryDetails";
import { ShippingDetails } from "../pages/Shipping/ShippingDetails";
// import { Shipping } from "../pages/Shipping/Shipping";
import { ShippingMemos } from "../pages/Shipping/ShippingMemos";
import { InvoiceDetails } from "../pages/Invoices/InvoiceDetails";
import { Invoices } from "../pages/Invoices/Invoices";
import { Messages } from "../pages/messages/Messages";
import { MessagesThread } from "../pages/messages/MessagesThread";

export const routesList: Array<Object> = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/orders",
    component: Orders,
  },
  {
    path: "/reports",
    component: Reports,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/createOrder",
    component: CreateOrder,
  },
  {
    path: "/productDetails",
    component: ProductDetails,
  },
  {
    path: "/orderhistory",
    component: OrderHistory,
  },
  {
    path: "/orderhistoryDetails",
    component: OrderHistoryDetails,
  },
  {
    path: "/shippingMemos",
    component: ShippingMemos,
  },
  {
    path: "/shippingDetails",
    component: ShippingDetails,
  },
  {
    path: "/invoices",
    component: Invoices,
  },
  {
    path: "/invoicedetails",
    component: InvoiceDetails,
  },
  {
    path: "/messages",
    component: Messages,
  },
  {
    path: "/messagesThread",
    component: MessagesThread,
  },
];
